import { motion } from "framer-motion";

const quotes = [
  { text: "Today's tax laws are so complicated that even a simple return can be confusing. There is no substitute for an experienced professional.", source: "On tax preparation" },
  { text: "Every set of books tells a story. My job is to make sure yours tells the truth — to your board, your auditors, and yourself.", source: "Zecharias A. Mesgane" },
  { text: "The right credential at the right time changes a career. The wrong one costs a year. Guidance is the difference.", source: "On career coaching" },
];

export default function Proof() {
  return (
    <section data-testid="proof-section" className="border-b border-linen">
      <div className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-36">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16 font-mono text-[11px] uppercase tracking-[0.35em] text-terra"
        >
          Principles of the Practice
        </motion.p>
        <div className="grid grid-cols-1 gap-px border border-linen bg-linen md:grid-cols-3">
          {quotes.map((q, i) => (
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.76, 0, 0.24, 1] }}
              className="flex flex-col justify-between bg-bone p-10 md:p-12"
              data-testid={`proof-quote-${i}`}
            >
              <p className="mb-8 font-serif text-xl italic leading-relaxed text-pine/90 md:text-2xl">
                &ldquo;{q.text}&rdquo;
              </p>
              <footer className="font-mono text-[10px] uppercase tracking-[0.25em] text-forest">{q.source}</footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
